module.exports = __webpack_public_path__ + "img/male4.25a2282a.jpeg";